import { getProblemLabel } from '@/src/utils/problemLabel'
import { ColumnDef } from '@tanstack/react-table'
import { MedDataMock, MedicalIncluded } from '@type/history.type'
import { Badge, Table2 } from '@ui'
import moment from 'moment'
import { useMemo } from 'react'
import { patientHistoryTableClassName } from '../Results/tableStyles'

type Props = {
  included?: MedicalIncluded[]
  isLoading?: boolean
  records: MedDataMock[]
}

export default function MedicalHistoryTable({ included = [], isLoading, records }: Props) {
  const columns = useMemo<ColumnDef<MedDataMock>[]>(
    () => [
      {
        accessorKey: 'condition',
        header: 'Condition',
        cell: ({ row }) => <span className="capitalize">{getProblemLabel(row.original, included) || '-'}</span>
      },
      {
        accessorKey: 'diagnosedDate',
        header: 'Diagnosed Date',
        cell: ({ row }) => (
          <span>
            {row.original.attributes.created_at
              ? moment(row.original.attributes.created_at).format('MMM DD, YYYY')
              : '-'}
          </span>
        )
      },
      {
        accessorKey: 'status',
        header: () => <div className="text-right">Status</div>,
        cell: ({ row }) => (
          <div className="text-right">
            <Badge label={row.original.meta.status} size="small" status={row.original.meta.status} />
          </div>
        )
      }
    ],
    [included]
  )

  return (
    <Table2
      className={patientHistoryTableClassName}
      columns={columns}
      data={records}
      emptyDescription="No history found."
      isLoading={isLoading}
      message="No history found"
      showPagination={false}
      wrapperClass="overflow-x-auto"
    />
  )
}
